// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import store from "./store";
import router from "./router";
import { sync } from "vuex-router-sync";
import { asset } from "@/utils/asset";

Vue.mixin({ methods: { asset } });

// import { library } from '@fortawesome/fontawesome-svg-core'

// /* import font awesome icon component */
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// /* import specific icons */
// import { faUserSecret } from '@fortawesome/free-solid-svg-icons'

// /* add icons to the library */
// library.add(faUserSecret)

// /* add font awesome icon component */
// Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false;

//Vue.component('Popper', Popper)
sync(store, router);

import "@/styles/_globals.css";

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then(registration => {
        console.log("Service Worker registered:", registration);
      })
      .catch(error => {
        console.log("Service Worker registration failed:", error);
      });
  });
}

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
  router,
  store
});
